exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rootContainer---1XRuo {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%; }\n\n@media print {\n  .rootContainer---1XRuo:nth-child(2) {\n    height: 1px !important;\n    max-height: 1px !important; } }\n", ""]);

// exports
exports.locals = {
	"rootContainer": "rootContainer---1XRuo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/root-container/index.scss
// module id = 1145
// module chunks = 3